import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CivicsComponent } from './components/civics/civics.component';
import { LoggedComponent } from './components/logged/logged.component';
import { SegurosPfComponent } from './components/seguros-pf/seguros-pf.component';
import { AuthResolver } from './core/resolvers/auth.resolver';
import { PessoaJuridicaComponent } from './components/pessoa-juridica/pessoa-juridica.component';
import { NpcComponent } from './components/npc/npc.component';
import { CorretoraComponent } from './components/corretora/corretora.component';
import { PessoaFisicaComponent } from './components/pessoa-fisica/pessoa-fisica.component';
import { GerentePfComponent } from './components/gerente-pf/gerente-pf.component';
import { ItauShopComponent } from './components/itau-shop/itau-shop.component';
import { IdpCallBackComponent } from './components/idp-callback/idp-callback.component';
import { CivicsV2Component } from './components/civics-v2/civics-v2.component';
import { ConsultoresSegurosPfComponent } from './components/consultores-seguros-pf/consultores-seguros-pf.component';
import { RedePjComponent } from './components/rede-pj/rede-pj.component';
import { IbbaComponent } from './components/ibba/ibba.component';
import { PessoaFisicaResizePocComponent } from './components/pessoa-fisica-resize-poc/pessoa-fisica-resize-poc.component';
import { RecuperacaoComponent } from './components/recuperacao/recuperacao.component';
import { OuvidoriaComponent } from './components/ouvidoria/ouvidoria.component';

export const routes: Routes = [
  {
    path: '',
    component: LoggedComponent,
  },
  {
    path: 'logged',
    component: LoggedComponent,
  },
  {
    path: 'centrais/civics',
    component: CivicsComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'civics',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/civics-v2',
    component: CivicsV2Component,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'civics-v2',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/seguros-pf',
    component: SegurosPfComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'seguros-pf',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/consultores-seguros-pf',
    component: ConsultoresSegurosPfComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'consultores-seguros-pf',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/pj',
    component: PessoaJuridicaComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'pj',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/npc',
    component: NpcComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'npc',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/corretora',
    component: CorretoraComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'corretora',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/pf',
    component: PessoaFisicaComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'pf',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/pf-resize-poc',
    component: PessoaFisicaResizePocComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'pf',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/gerentes-pf',
    component: GerentePfComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'gerentes-pf',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/itau-shop',
    component: ItauShopComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'itau-shop',
      authMode: 'popup',
    },
  },
  {
    path: 'idp-callback',
    component: IdpCallBackComponent,
  },
  {
    path: 'centrais/ibba',
    component: IbbaComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'ibba',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/rede-pj',
    component: RedePjComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'rede-pj',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/recuperacao',
    component: RecuperacaoComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'recuperacao',
      authMode: 'popup',
    },
  },
  {
    path: 'centrais/ouvidoria',
    component: OuvidoriaComponent,
    resolve: { isAuthenticated: AuthResolver },
    data: {
      authService: 'nice',
      centralId: 'ouvidoria',
      authMode: 'popup',
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
